import { render, staticRenderFns } from "./EditDnsBatch.vue?vue&type=template&id=61122b01&scoped=true"
import script from "./EditDnsBatch.vue?vue&type=script&lang=js"
export * from "./EditDnsBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61122b01",
  null
  
)

export default component.exports